import { Component, ElementRef, OnInit, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import $ from "jquery/dist/jquery";
import { AlertService, UserRoleService } from "../../_services/index";
interface MenuItem {
  id: number;
  label: string;
  type: number;
  expanded: boolean;
  children: SubMenuItem[];
  checked?: boolean;
}

interface SubMenuItem {
  menu_id: number;
  sub_id: number;
  label: string;
  type: number;
  checked?: boolean;
}

@Component({
  selector: "app-user-role-new",
  templateUrl: "./user-role-new.component.html",
  styleUrls: ["./user-role-new.component.css"],
})
export class UserRoleNewComponent implements OnInit, AfterViewInit {
  showloding = true;
  lodingImage = false;
  menuList: MenuItem[] = [];
  getRoleMenu: any;
  getRoleSubMenu: any;
  setMenu: string[] = [];
  setSubMenu: string[] = [];
  urlParams: any;
  userName: string;
  userType: any;
  wepMenuList: any;
  ciiMenuList: any;
  getUserRole = {
    menu: "",
    sub: "",
  };

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private dataService: UserRoleService,
    public elRef: ElementRef
  ) {}

  ngOnInit() {
    this.loadShow();
    this.activatedRoute.params.subscribe((params) => {
      this.urlParams = params["id"];
    });

    setTimeout(() => {
      this.showloding = false;
      this.lodingImage = true;
    }, 500);

    this.dataService.getNewRoleData().subscribe((data) => {
      this.loadHide();

      this.wepMenuList = data["wep_menu"].map((item) => ({
        ...item,
        checked: false,
        expanded: true, // ✅ all WEP open by default
        children: item.children.map((child) => ({ ...child, checked: false })),
      }));

   
      this.ciiMenuList = data["cii_menu"].map((item) => ({
        ...item,
        checked: false,
        expanded: true, // ✅ all CII closed by default
        children: item.children.map((child) => ({ ...child, checked: false })),
      }));

      this.getUser();
    });
  }

  toggleChild(item: MenuItem, type: "wep" | "cii") {
    if (type === "cii") {
      // User clicked individual CII dropdown
      item.expanded = !item.expanded;
    } else {
      // WEP → allow multiple open/close independently
      item.expanded = !item.expanded;
    }
  }



  ngAfterViewInit() {
    $("#collapseMain").on("shown.bs.collapse", () => {
      $("#innerAccordion .collapse").collapse("show");
    });

    $("#collapseMain").on("hidden.bs.collapse", () => {
      $("#innerAccordion .collapse").collapse("hide");
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  getUser() {
    this.dataService.getUser(this.urlParams).subscribe({
      next: (data) => {
        this.userName = data["user"].name;
        this.userType = data["user"].type;

        if (data["roleData"] != null) {
          if (data["roleData"].menu_id) {
            this.getUserRole["menu"] = data["roleData"].menu_id.split(",");
          }
          if (data["roleData"].sub_menu_id) {
            this.getUserRole["sub"] = data["roleData"].sub_menu_id.split(",");
          }
        }

        this.getRoleMenu = this.getUserRole.menu || [];
        this.getRoleSubMenu = this.getUserRole.sub || [];

        // Process wepMenuList
        if(this.wepMenuList){
          this.wepMenuList.forEach((item) => {
          if (this.getRoleMenu.includes(item.id.toString())) {
            item.checked = true;
            if (!this.setMenu.includes(item.id.toString())) {
              this.setMenu.push(item.id.toString());
            }
          }
          item.children.forEach((child) => {
            if (this.getRoleSubMenu.includes(child.sub_id.toString())) {
              child.checked = true;
              if (!this.setSubMenu.includes(child.sub_id.toString())) {
                this.setSubMenu.push(child.sub_id.toString());
              }
              item.checked = true; // Parent is checked if any child is checked
            }
          });
        });
        }
     

        // Process ciiMenuList
      if(this.ciiMenuList){

        this.ciiMenuList.forEach((item) => {
          if (this.getRoleMenu.includes(item.id.toString())) {
            item.checked = true;
            if (!this.setMenu.includes(item.id.toString())) {
              this.setMenu.push(item.id.toString());
            }
          }
          item.children.forEach((child) => {
            if (this.getRoleSubMenu.includes(child.sub_id.toString())) {
              child.checked = true;
              if (!this.setSubMenu.includes(child.sub_id.toString())) {
                this.setSubMenu.push(child.sub_id.toString());
              }
              item.checked = true; // Parent is checked if any child is checked
            }
          });
        });}
      },
      error: (error) => {
        this.alertService.error("Error fetching user data: " + error.message);
      },
    });
  }

  selectMenu(event: Event, item: MenuItem) {
    const checked = (event.target as HTMLInputElement).checked;
    item.checked = checked;

    if (checked) {
      if (!this.setMenu.includes(item.id.toString())) {
        this.setMenu.push(item.id.toString());
      }
      if (item.children.length) {
        item.children.forEach((child) => {
          child.checked = true;
          if (!this.setSubMenu.includes(child.sub_id.toString())) {
            this.setSubMenu.push(child.sub_id.toString());
          }
        });
      }
    } else {
      this.setMenu = this.setMenu.filter((id) => id !== item.id.toString());
      if (item.children.length) {
        item.children.forEach((child) => {
          child.checked = false;
          this.setSubMenu = this.setSubMenu.filter(
            (id) => id !== child.sub_id.toString()
          );
        });
      }
    }
  }

  selectSubMenu(event: Event, item: MenuItem, child: SubMenuItem) {
    const checked = (event.target as HTMLInputElement).checked;
    child.checked = checked;

    if (checked) {
      if (!this.setSubMenu.includes(child.sub_id.toString())) {
        this.setSubMenu.push(child.sub_id.toString());
      }
      item.checked = true;
      if (!this.setMenu.includes(item.id.toString())) {
        this.setMenu.push(item.id.toString());
      }
    } else {
      this.setSubMenu = this.setSubMenu.filter(
        (id) => id !== child.sub_id.toString()
      );
      const hasCheckedChild = item.children.some((c) => c.checked);
      item.checked = hasCheckedChild;
      if (!hasCheckedChild) {
        this.setMenu = this.setMenu.filter((id) => id !== item.id.toString());
      }
    }
  }

  update() {
    // Validate both wepMenuList and ciiMenuList
    const invalidParents = [...this.wepMenuList, ...this.ciiMenuList].filter(
      (item) =>
        item.checked &&
        item.children.length &&
        !item.children.some((child) => child.checked)
    );

    if (invalidParents.length) {
      this.alertService.error(
        "Please select at least one child for each checked parent with children."
      );
      this.showloding = false;
      this.lodingImage = true;
      return;
    }

    this.showloding = true;
    this.lodingImage = false;
    this.dataService
      .addUserRole(this.setMenu, this.setSubMenu, this.urlParams)
      .subscribe({
        next: (data) => {
          this.alertService.success("User Role Update successful", true);
          this.showloding = false;
          this.lodingImage = true;
          this.back();
        },
        error: (error) => {
          this.alertService.error(error);
          this.showloding = false;
          this.lodingImage = true;
        },
      });
  }

  back() {
    this.router.navigate(["user"]);
  }
}
